import { connect } from 'react-redux';
import DataRoom from '../../../components/data_room';

import createComment from '../../../api/commentApi';

import {
  createSection,
  renameSection,
  deleteSection,
  updateSectionPosition,
  createFile,
  moveFile,
  updateFile,
  updateFilePosition,
  deleteFile,
} from '../../../api/company/dataRoomApi';

const mapStateToProps = state => ({
  editor: true,
  company: state.company,
  currentUser: state.currentUser,
  dataRoom: state.dataRoom,
  comments: state.comments,
});

const mapDispatchToProps = {
  createSection,
  renameSection,
  deleteSection,
  updateSectionPosition,
  createFile,
  moveFile,
  updateFile,
  updateFilePosition,
  deleteFile,
  createComment,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataRoom);
